var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.07838 4.07113C2.17172 4.07113 2.26505 4.07113 2.35882 4.07113C5.57053 4.07113 8.78269 4.07113 11.9944 4.072C12.11 4.072 12.2286 4.07156 12.3407 4.09512C12.6155 4.15312 12.7925 4.38297 12.793 4.65948C12.7934 4.9434 12.6059 5.1763 12.3202 5.22951C12.2142 5.24913 12.1034 5.24739 11.9948 5.24739C8.77571 5.24826 5.55658 5.24826 2.33745 5.24826C2.24761 5.24826 2.15776 5.24826 2.00991 5.24826C2.11982 5.3634 2.18131 5.431 2.24586 5.49555C3.14997 6.39966 4.05409 7.30378 4.9582 8.20789C4.99396 8.24365 5.03147 8.27898 5.06505 8.31692C5.28835 8.57076 5.28268 8.91705 5.05284 9.14166C4.8291 9.36016 4.46624 9.35973 4.22854 9.12596C3.74661 8.65231 3.27078 8.17256 2.79321 7.69456C1.94056 6.84147 1.08791 5.98882 0.236139 5.13443C-0.0783153 4.81867 -0.0791879 4.50072 0.234831 4.18627C1.55415 2.86521 2.87477 1.54458 4.19583 0.225269C4.47365 -0.0521143 4.82343 -0.0743577 5.0668 0.163774C5.32499 0.416297 5.3106 0.758229 5.02057 1.04957C4.11776 1.95499 3.21321 2.85867 2.30779 3.76103C2.22231 3.84608 2.12592 3.92022 2.03477 3.9996C2.04873 4.02359 2.06356 4.04758 2.07838 4.07113Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.e636335b49474db0db205234fb893855.svg";
export { ForwardRef as ReactComponent };